import api from '../index'

/**
 * 认证管理模块接口
 */

// 登录参数类型
interface LoginParams {
  account: string
  password: string
}

// 修改密码参数类型
interface PasswordEditParams {
  oldPassword: string
  password: string
}

// 发送验证码参数类型
interface SendVerifyCodeParams {
  phone: string
  type?: string
}

// 重置密码参数类型
interface ResetPasswordParams {
  phone: string
  password: string
  verifyCode: number
}

// 企业微信登录参数类型
interface WecomLoginParams {
  code: string
  state?: string
}

// 企业微信绑定参数类型
interface WecomBindParams {
  code: string
}

export default {
  // 登录
  login: (data: LoginParams) => {
    return api.post('/auth/login', data)
  },

  // 获取权限
  getPermission: () => {
    return api.get('/auth/getPermission')
  },

  // 获取用户信息
  getUserInfo: () => {
    return api.get('/auth/getUserInfo')
  },

  // 修改密码
  changePassword: (data: PasswordEditParams) => {
    return api.post('/auth/changePassword', data)
  },

  // 发送验证码
  sendVerifyCode: (data: SendVerifyCodeParams) => {
    return api.post('/auth/sendVerifyCode', data)
  },

  // 重置密码
  resetPassword: (data: ResetPasswordParams) => {
    return api.post('/auth/resetPassword', data)
  },

  // 获取企业微信登录参数
  getWecomLoginParams: (state?: string) => {
    return api.get('/auth/getWecomLoginParams', { params: { state } })
  },

  // 获取企业微信绑定面板参数
  getWecomBindParams: () => {
    return api.get('/auth/getWecomBindParams')
  },

  // 企业微信登录
  wecomLogin: (data: WecomLoginParams) => {
    return api.post('/auth/wecomLogin', data)
  },

  // 绑定企业微信账号
  bindWecom: (data: WecomBindParams) => {
    return api.post('/auth/bindWecom', data)
  },

  // 解绑企业微信账号
  unbindWecom: () => {
    return api.post('/auth/unbindWecom')
  },

  // 获取企业微信绑定状态
  getWecomBindStatus: () => {
    return api.get('/auth/getWecomBindStatus')
  },
}
